import fetch from 'isomorphic-fetch'
import { v4 as uuid } from 'uuid'
import OAuth from './oauth'
import { ENDPOINT } from '../settings'

export default {
  customers: {
    get (id) {
      let URL = `${ENDPOINT}/api/v2/customer`

      if (id && typeof id === 'string' && id.trim() !== '') {
        URL += `/${id}`
      }

      return fetch(URL, {
        method: 'GET',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` }
      }).then(response => response.json())
    },

    create (data) {
      return fetch(`${ENDPOINT}/api/v2/customer`, {
        method: 'POST',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` },
        body: JSON.stringify(data)
      }).then(response => response.json())
    },

    update (id, data) {
      return fetch(`${ENDPOINT}/api/v2/customer/${id}`, {
        method: 'PATCH',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` },
        body: JSON.stringify(data)
      }).then(response => response.json())
    },

    destroy (id) {
      return fetch(`${ENDPOINT}/api/v2/customer/${id}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` }
      }).then(response => response.json())
    }
  },

  credentials: {
    get (id) {
      let URL = `${ENDPOINT}/api/v2/client`

      if (id && typeof id === 'string' && id.trim() !== '') {
        URL += `/${id}`
      }

      return fetch(URL, {
        method: 'GET',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` }
      }).then(response => response.json())
    },

    create (data) {
      return fetch(`${ENDPOINT}/api/v2/client`, {
        method: 'POST',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` },
        body: JSON.stringify(data)
      }).then(response => response.json())
    },

    destroy (id) {
      return fetch(`${ENDPOINT}/api/v2/client/${id}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` }
      }).then(response => response.json())
    }
  },

  projects: {
    get (id) {
      let URL = `${ENDPOINT}/api/v2/project`

      if (id && typeof id === 'string' && id.trim() !== '') {
        URL += `/${id}`
      }

      return fetch(URL, {
        method: 'GET',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` }
      }).then(response => response.json())
    },

    create (data) {
      const random = uuid().split('-').pop()
      return fetch(`${ENDPOINT}/api/v2/project`, {
        method: 'POST',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` },
        body: JSON.stringify({
          ...data,
          status: 'beta',
          domains: [ `${random}.beta.iloyalty.io` ],
          settings: {
            basicSettings: {
              domainName: `${random}.beta.iloyalty.io`
            }
          }
        })
      }).then(response => response.json())
    },

    update (id, data) {
      return fetch(`${ENDPOINT}/api/v2/project/${id}`, {
        method: 'PATCH',
        mode: 'cors',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` },
        body: JSON.stringify(data)
      }).then(response => response.json())
    },

    move (id, destination) {
      return fetch(`${ENDPOINT}/api/v2/project/${id}/move/${destination}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` }
      })
        .then(response => {
          if (!response.ok) {
            return response.text().then(text => {
              throw new Error(`${response.status} error (${response.statusText}) in move request: ${text}`)
            })
          }

          return response.json()
        })
    },

    destroy (id) {
      return fetch(`${ENDPOINT}/api/v2/project/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${OAuth.getAccessToken()}` },
        mode: 'cors'
      }).then(response => response.json())
    }
  }
}



// WEBPACK FOOTER //
// ./lib/api.js